export default class CancellationOutcomes {
  static FEEDBACK_SAVED = "feedbackSaved";

  static DISCOUNT_APPLIED = "discountApplied";

  static CANCELLATION_SCHEDULED = "cancellationScheduled";

  static CANCELED = "canceled";

  static SUBSCRIPTION_RESUMED = "subscriptionResumed";
}
